<template>
    <div>
        <zm-row>
            <zm-date-picker size="small"
                v-model="filter.daterange"
                type="daterange"
                range-separator="to"
                class="date-in-line"
                clear-icon="zm-icon-error"
                clearable
                value-format="yyyy-MM-dd"></zm-date-picker>
            <b>className:</b><zm-input size="small" v-model.trim="filter.className" class="input-in-line" clearable></zm-input>
            <b>methodName: </b><zm-input size="small" v-model.trim="filter.methodName" class="input-in-line" clearable></zm-input>
            <b>param: </b><zm-input size="small" v-model.trim="filter.param" class="input-in-line" clearable></zm-input>
            <b>operator:</b><zm-input size="small" v-model.trim="filter.operator" class="input-in-line" clearable></zm-input>
            <zm-button size="small" @click="fetchData()" type="icon" class="btn-in-line" icon="zm-icon-search"></zm-button>
            <!-- <zm-button size="small" @click="deleteLogs()" type="icon" class="btn-in-line" icon="zm-icon-delete"></zm-button> -->
        </zm-row>
        <div class="table-container">
            <zm-table resizable border :data="list" v-loading="loading">
                <zm-table-column prop="className" label="className" align="center">
                </zm-table-column>
                <zm-table-column prop="methodName" label="methodName" align="center">
                </zm-table-column>
                <zm-table-column prop="operator" label="operator" align="center">
                </zm-table-column>
                <zm-table-column prop="param" label="param" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.param.length > 50">{{scope.row.param.substring(0, 50)}}</span>
                        <span v-else>{{scope.row.param}}</span>
                    </template>
                </zm-table-column>
                <zm-table-column prop="requestIp" label="requestIp" align="center">
                </zm-table-column>
                <zm-table-column prop="createdTime" label="operateTime" align="center" :formatter="setTime" :show-overflow-tooltip="true">
                </zm-table-column>
                <zm-table-column align="center" width="80px">
                    <template slot-scope="scope">
                        <zm-button size="small" type="icon" icon="zm-icon-eyes" @click="showParam(scope.row.param)" title="show param"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination @current-change="paginationChange"
                    @size-change="handleSizeChange"
                    :current-page.sync="pageable.page" :page-size="pageable.size"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="pageable.total">
                </zm-pagination>
            </div>
        </div>
        <zm-dialog :visible.sync="dialogVisible" show-close title="Param">
            {{ param }}
        </zm-dialog>
    </div>
</template>
<script>
import { getAuditLog, deleteLogs } from '../../api/index'
export default {
    name: 'auditlog',
    data () {
        return {
            list: [],
            loading: false,
            pageable: {
                page: 1,
                size: 10,
                total: 0
            },
            filter: {
                className: '',
                methodName: '',
                param: '',
                daterange: [],
                from: '',
                to: '',
                operator: ''
            },
            param: '',
            dialogVisible: false
        }
    },
    created () {
        if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
            this.filter = JSON.parse(localStorage.params).filter
            this.pageable.page = JSON.parse(localStorage.params).page
            this.pageable.size = JSON.parse(localStorage.params).size
        }
        localStorage.params = ''
        localStorage.path = this.$route.path
        this.fetchData()
    },
    watch: {
        'filter.className' () {
            this.setURL()
        },
        'filter.methodName' () {
            this.setURL()
        },
        'filter.param' () {
            this.setURL()
        },
        'filter.operator' () {
            this.setURL()
        },
        'filter.daterange' () {
            this.setURL()
        },
        'filter.from' () {
            this.setURL()
        },
        'filter.to' () {
            this.setURL()
        },
        'pageable.page' () {
            this.setURL()
        },
        'pageable.size' () {
            this.setURL()
        }
    },
    methods: {
        setURL () {
            const { filter } = this
            const { page, size } = this.pageable
            const data = { path: this.$route.path, filter, page, size }
            localStorage.params = JSON.stringify(data)
        },
        setTime (row, column, cellValue, index) {
            let time = row[column.property]
            return new Date(parseInt(time)).toLocaleString()
        },
        fetchData () {
            this.loading = true
            if (this.filter.daterange) {
                this.filter.from = this.filter.daterange[0]
                this.filter.to = this.filter.daterange[1]
            } else {
                this.filter.to = ''
                this.filter.from = ''
            }
            const { className, methodName, param, operator, from, to } = this.filter
            getAuditLog(className, methodName, param, operator, from, to, this.pageable.size, this.pageable.page - 1).then(response => {
                const { content, pageable: { page, size }, total } = response
                this.list = content
                this.pageable.total = total
                this.pageable.page = page + 1
                this.pageable.size = size
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        deleteLogs () {
            this.$confirm('This will permanently delete the tasks. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                if (this.filter.daterange) {
                    this.filter.from = this.filter.daterange[0]
                    this.filter.to = this.filter.daterange[1]
                } else {
                    this.filter.to = ''
                    this.filter.from = ''
                }
                const { className, methodName, param, operator, from, to } = this.filter
                deleteLogs(className, methodName, param, operator, from, to).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Submit delete success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        },
        handleSizeChange (value) {
            this.pageable.size = value
            this.fetchData()
        },
        paginationChange () {
            this.fetchData()
        },
        showParam (data) {
            this.param = data
            this.dialogVisible = true
        }
    }
}
</script>
<style>
.date-in-line {
    height: 32px;
    width: 180px;
    margin-right: 10px;
}
.date-in-line.zm-date-editor.zm-input, .date-in-line.zm-date-editor.zm-input__inner {
    font-size: 13px;
    width: 230px;
    height: 32px;
    line-height: 24px;
}
.status-select{
    width: 150px;
    margin: 10px;
}
.zm-date-editor.zm-input, .zm-date-editor.zm-input__inner{
    width: 230px;
}
.input-in-line{
    margin: 10px;
    width: 100px;
}
.btn-in-line{
    margin: 10px 0 10px 0;
}
.btn-in-line-right {
    float: right;
    margin: 15px;
}
.input-with-select{
    float: right;
    margin: 10px;
    width: 250px;
}
.search-status {
    float: right;
}
.index-select {
    width: 110px;
}
.demo-table-expand {
    font-size: 0;
}
.demo-table-expand label {
    width: 95px;
    color: #99a9bf;
}
.demo-table-expand .zm-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
}
.topic-detail-popover {
  height: 300px;
  overflow: auto;
}
.taskTitle {
    text-align: center;
    color: #0E71EB;
}
.zm-input-group{
    width: 20%;
}
.search-input{
    float: right;
    margin: 10px;
}
</style>
